import {BLOCK_ALIGNMENT, BUTTON_COLORS, TEXT_ALIGNMENT} from '../constants/design-constants.ts';

export const getColorScheme = (value:string) =>{
    if (!value) {
        return '';
    }
    var colorClass = `bg-color-scheme-${value.toLowerCase().replace(' ', '-')}`;
    const result = {};
    result[colorClass] = true;
    return result;
}

export const getBlockWidth = (value:string) =>{
    if (!value) {
        return '';
    }

    var blockWidthCalss = `bg-${value.toLowerCase().replace(' ', '-')}`;
    const result = {};
    result[blockWidthCalss] = true;
    return result;
}

export const getItemAlignment = (value:string) =>{
    var colorClass = `bg-align-items-${value.toLowerCase().replace(' ', '-')}`;
    const result = {};
    result[colorClass] = true;
    return result;
}

export const getBlockAlignment = (value:string) =>{
    return getConstantValues(value, BLOCK_ALIGNMENT);
}
export const getTextAlignment = (value:string) =>{
    return getConstantValues(value, TEXT_ALIGNMENT);
}
export const getButtonColors = (value:string) =>{
    return getConstantValues(value, BUTTON_COLORS);
}

export const getButtonSize = (value:string) =>{
    if (!value) {
        return '';
    }

    var buttonSize = `${value.toLowerCase().replace(' ', '-')}`;
    const result = {};
    result[buttonSize] = true;
    return result;
}

const getConstantValues = (value:string, constants:object) =>{
    const matchedValue =  constants[value.toLowerCase()] ?? "";
    if(!matchedValue){
        return {};
    }
    const result = {};
    result[matchedValue] = true;
    return result;
}
